<script>
import Layout from './app'
export default {
  components: { Layout },
}
</script>

<template>
  <Layout>
    <slot />
  </Layout>
</template>
